import React from 'react'
import styled from 'styled-components'
import Theme from 'components/common/Theme/Theme'
import Button from 'components/common/Button/Button'

const Knowledge = ({ ...props }) =>
  <KnowledgeBlock>
    <Headline>TIRE KNOWLEDGE</Headline>
    <Title>Benefits of Snow Tires</Title>
    <Description>Tires help keep you and your passengers safe.
    Tire America gives you the tire information you need to make that investment confidently.</Description>
    <KnowledgeButton>Learn more</KnowledgeButton>
  </KnowledgeBlock>

export default Knowledge

const KnowledgeBlock = styled.div`
  width: 1200px;
  padding: 136px 60px;
  margin: 0 auto;
  background-size: cover;
`

const Title = styled.div`
  font-size: 48px;
  font-weight: 300;
  margin-bottom: 10px;
  color: ${Theme.colors.blue};
`

const Description = styled.div`
  width: 510px;
  line-height: 30px;
  font-size: 16px;
  font-weight: 400;
`

const Headline = styled.div`
  margin-bottom: 15px;
  font-size: 14px;
  font-weight: 500;
  color: ${Theme.colors.lightblue};
  text-transform: uppercase;
`

const KnowledgeButton = styled(Button)`
  height: 50px;
  width: 166px;
  padding: 10px;
  margin-top: 30px;
  border: 0;
  background: ${Theme.colors.lightblue};
  font-size: 20px;
  font-weight: 700;
  color: ${Theme.colors.white};
  text-align: center;
  text-transform: uppercase;
`
